import { Dispatch } from '@reduxjs/toolkit'
import { ClientsApiClient } from 'utils/api/clientsApi'
import { WorldCheckApiClient } from 'utils/api/worldCheckApi'

import { complianceSlice } from './compliance.slice'

export const getCountryComplianceMRLOAnalysesAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const data = await clientsApiClient.getCountryComplianceMRLOAnalyses()
      dispatch(complianceSlice.actions.getCountryComplianceMRLOAnalyses(data))
    } catch (e) {
      console.error('Cannot get mrlo statuses', e)
    }
  }
}

export const getCountryComplianceInternalRiskLevelAction = (clientsApiClient: ClientsApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const data = await clientsApiClient.getCountryComplianceInternalRiskLevel()
      dispatch(complianceSlice.actions.getCountryComplianceInternalRiskLevel(data))
    } catch (e) {
      console.error('Cannot get internal risk levels statuses', e)
    }
  }
}

export const getComplianceWorldCheckTypesAction = (worldCheckApiClient: WorldCheckApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const data = await worldCheckApiClient.getWorldCheckTypes()
      dispatch(complianceSlice.actions.getComplianceWorldCheckTypes(data))
    } catch (e) {
      console.error('Cannot get world check types', e)
    }
  }
}
